import { useCallback } from 'react';
import { AuthRole } from 'common/enums/enums';
import { useAuth } from 'hooks';

export const useRoleContext = () => {
  const { user, isAuthenticated } = useAuth();

  const activeRole = user?.activeRole;
  
  const availableRoles = user?.roles || [];
  
  const canSwitchToRole = useCallback((role: AuthRole) => {
    return availableRoles.includes(role);
  }, [availableRoles]);

  const hasRole = useCallback((role: AuthRole) => {
    return availableRoles.includes(role);
  }, [availableRoles]);

  const isActiveRole = useCallback((role: AuthRole) => {
    return activeRole === role;
  }, [activeRole]);

  const getTargetRole = useCallback(() => {
    if (activeRole === AuthRole.Renter) {
      return AuthRole.Landlord;
    } else if (activeRole === AuthRole.Landlord) {
      return AuthRole.Renter;
    }
    return null;
  }, [activeRole]);

  const getSwitchButtonText = useCallback(() => {
    const targetRole = getTargetRole();
    if (targetRole === AuthRole.Renter) {
      return 'Switch to Renting';
    } else if (targetRole === AuthRole.Landlord) {
      return 'Switch to Listing';
    }
    return null;
  }, [getTargetRole]);

  const canSwitchRoles = useCallback(() => {
    return isAuthenticated 
      && activeRole 
      && (activeRole === AuthRole.Renter || activeRole === AuthRole.Landlord);
  }, [isAuthenticated, activeRole]);

  return {
    activeRole,
    availableRoles,
    canSwitchToRole,
    hasRole,
    isActiveRole,
    getTargetRole,
    getSwitchButtonText,
    canSwitchRoles,
  };
};
